
import React, {FC} from 'react';
import {ApptProps} from 'components/ApptDetails2';
import {useContextRemaining} from 'components/useHolder/remaining';
import {Parsed} from 'templates/booking/Booking/ModalContent/parse';

import Options from './Options';

import * as styles from './styles.module.scss';

type RenewEarlyProps = {
	appt: ApptProps
	membership: Parsed['membership']
}

const RenewEarly: FC<RenewEarlyProps> = ({appt, membership}) => {
	const remaining = useContextRemaining();
	return (
		<div className={styles.renew}>
			<p>
				You have <em>{remaining} remaining</em> to
				complete your reservation.
			</p>
			<p>
				Thank you for being an active BodySpec member! Your membership
				for {membership.text} renews on <em>{membership.renewsOn}</em>.
			</p>
			<p>
				To book this appointment, would you like to renew early?
			</p>
			<Options
				appt={appt}
				membership={membership}
			/>
		</div>
	);
};

export default RenewEarly;
